import { render, staticRenderFns } from "./EditHistory.vue?vue&type=template&id=2299606c&scoped=true"
import script from "./EditHistory.vue?vue&type=script&lang=js"
export * from "./EditHistory.vue?vue&type=script&lang=js"
import style0 from "./EditHistory.vue?vue&type=style&index=0&id=2299606c&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2299606c",
  null
  
)

export default component.exports